const GUEST_BUCKET_COUNT = 1000000;

/**
 * NOTE: Below hashing fn is taken from stackoverflow...
 * should figure out the ideal hashing function for this.
 * Likely needs larger than 32-bit hashing given the bucketing scale is in 250k-2million
 * @see https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
 */

/*
    cyrb53 (c) 2018 bryc (github.com/bryc)
    License: Public domain. Attribution appreciated.
    A fast and simple 53-bit string hash function with decent collision resistance.
    Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
*/
const cyrb53 = (str: string, seed = 0): number => {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;

  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 = Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 = Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

/**
 * Hashes a unique device ID into an anonymous guest bucket number, which we provide
 * to LaunchDarkly for anonymous user contexts.
 * This was originally put in place to reduce our LaunchDarkly context usage.
 * @see https://github.com/janetechinc/iheartjane/pull/16108
 */
export const guestBucketForDeviceID = (deviceID: string): string => {
  const hash = cyrb53(deviceID);
  const bucket_number = hash % (GUEST_BUCKET_COUNT - 1);
  return 'guest:' + bucket_number;
};
